import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { useApi } from "../../lib/api";

const ease = [0.2, 0.7, 0.1, 1];

// Like the printed cover: the artwork full width and only a few small lines of type.
export const CoverBanner = ({ cover }) => {
  const { data: b } = useApi("/banner");
  if (!b) return <section className="pt-[76px] sm:pt-[92px]"><div className="aspect-video bg-paper" data-testid="street-banner-loading" /></section>;
  const title = (b.title ?? "").replace(/\n/g, " ").trim();
  const external = /^https?:\/\//.test(b.button_link ?? "");
  return (
    <section className="pt-[76px] sm:pt-[92px]" data-testid="street-banner">
      <motion.img
        src={b.image}
        alt={title}
        initial={{ opacity: 0.4, scale: 1.02 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 1.2, ease }}
        className="w-full h-auto block"
        data-testid="street-banner-image"
      />
      <div className="max-w-[1440px] mx-auto px-5 sm:px-10 pt-4 pb-14 sm:pb-20 grid gap-5 lg:grid-cols-12 border-b border-ink">
        <div className="lg:col-span-7">
          <div className="flex justify-between gap-4 kicker text-ink/70">
            <span data-testid="street-banner-kicker">{b.kicker || "Cover story"}</span>
            <span className="lg:hidden">Issue 27 · Autumn 2026</span>
          </div>
          <h1 className="dz-type text-[clamp(1.9rem,4vw,3.6rem)] mt-3 max-w-[900px]" data-testid="street-banner-title" data-size={b.title_size ?? "medium"}>
            <span data-testid="street-banner-headline">{title}</span>
          </h1>
        </div>
        <div className="lg:col-span-5 flex flex-col justify-between gap-5">
          <p className="hidden lg:block kicker text-ink/70 text-right">Issue 27 · Autumn 2026 · The New Rebels issue</p>
          {b.text && <p className="text-sm sm:text-base leading-relaxed text-ink/80 max-w-md lg:ml-auto" data-testid="street-banner-text">{b.text}</p>}
          <div className="flex flex-wrap gap-x-6 gap-y-2 lg:justify-end">
            {cover && (
              <Link to={`/article/${cover.slug}`} className="group kicker inline-flex items-center gap-1.5 border-b-2 border-pink pb-1 hover:text-pink transition-colors" data-testid="street-banner-cover-btn">
                Read the cover story <ArrowUpRight className="h-3.5 w-3.5 transition-transform group-hover:rotate-45" />
              </Link>
            )}
            {b.button_label && b.button_link && (
              <a
                href={b.button_link}
                {...(external ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                className="kicker border-b-2 border-ink pb-1 hover:text-pink hover:border-pink transition-colors"
                data-testid="street-banner-culture-btn"
              >
                {b.button_label}
              </a>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};
